import React, { useEffect, useState } from 'react';
import { gsap } from 'gsap';
import './Slide8.css';

const Slide8Component = () => {
  const [typedText, setTypedText] = useState('');

  useEffect(() => {
    const tl = gsap.timeline();

    tl.set('.slide8-header', { opacity: 1 });

    tl.add(() => {
      const text = "Comment tout s'articule ensemble ?";
      let index = 0;
      const typeInterval = setInterval(() => {
        if (index <= text.length) {
          setTypedText(text.slice(0, index));
          index++;
        } else {
          clearInterval(typeInterval);
        }
      }, 50);
    }, '+=0.8');

    tl.to('.slide8-search-button', {
      scale: 1.1,
      boxShadow: '0 0 40px rgba(0, 212, 255, 0.8)',
      duration: 0.3,
      repeat: 1,
      yoyo: true
    }, '+=2');

    tl.fromTo('.slide8-main-title',
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }
    , '+=0.3');

    tl.fromTo('.slide8-separator',
      { opacity: 0, scaleX: 0 },
      { opacity: 1, scaleX: 1, duration: 0.8, ease: 'power2.inOut' }
    , '-=0.4');

    tl.fromTo('.ecosystem-card',
      { opacity: 0, y: 50, scale: 0.95 },
      { opacity: 1, y: 0, scale: 1, duration: 0.7, stagger: 0.12, ease: 'power2.out' }
    , '+=0.2');

    tl.fromTo('.discover-button',
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }
    , '+=0.3');

    return () => tl.kill();
  }, []);

  return (
    <div className="slide-content slide-8-transition">
      <header className="slide8-header">
        <div className="slide8-header-content">
          <div className="slide8-logo-small">
            MAR<span className="neon-text">IA</span>NE
          </div>
          <form className="slide8-search-form">
            <div className="slide8-search-box">
              <input
                type="text"
                className="slide8-search-input"
                placeholder="Rechercher..."
                value={typedText}
                readOnly
              />
              <button type="button" className="slide8-search-button">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              </button>
            </div>
          </form>
        </div>
      </header>

      <div className="slide8-content">
        <div className="slide8-main-title">
          <h1 className="slide8-h1">L'Écosystème MarIAne</h1>
          <p className="slide8-sub">Une Architecture Intégrée et Modulaire</p>
        </div>

        <div className="slide8-separator"></div>

        <div className="ecosystem-grid">
          <div className="ecosystem-card">
            <div className="eco-number">01</div>
            <div className="eco-icon">
              <i className="bi bi-search"></i>
            </div>
            <h3>Moteur de Recherche Sémantique</h3>
            <ul>
              <li>Interface de recherche intelligente</li>
              <li>Résultats enrichis par IA</li>
              <li>Cards et summaries automatiques</li>
              <li>Chat contextuel intégré</li>
            </ul>
          </div>

          <div className="ecosystem-card">
            <div className="eco-number">02</div>
            <div className="eco-icon">
              <i className="bi bi-browser-chrome"></i>
            </div>
            <h3>Navigateur Sécurisé</h3>
            <ul>
              <li>Proxy MITM pour protection totale</li>
              <li>Technologies anti-tracking</li>
              <li>Contrôle du contenu en temps réel</li>
              <li>Extensions Chrome compatibles</li>
            </ul>
          </div>

          <div className="ecosystem-card">
            <div className="eco-number">03</div>
            <div className="eco-icon">
              <i className="bi bi-cpu-fill"></i>
            </div>
            <h3>Core IA</h3>
            <ul>
              <li>Modèles de langage embarqués</li>
              <li>API WebSocket temps réel</li>
              <li>Architecture modulaire (Tab, Extension, Shield)</li>
              <li>Séparation UI/Logique pour performance</li>
            </ul>
          </div>
        </div>

        <a
          href="https://mariane.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="discover-button"
        >
          <span>Découvrir MarIAne</span>
          <i className="bi bi-arrow-right"></i>
        </a>
      </div>
    </div>
  );
};

export default Slide8Component;
